// import React from "react";
// import { useForm, Controller, watch } from "react-hook-form";
// import { yupResolver } from "@hookform/resolvers/yup";
// import * as yup from "yup";
// import { Grid, Card, Typography } from "@mui/material";
// import { Input, Select, Button, Checkbox, Upload } from "antd";
// import { UploadOutlined } from "@ant-design/icons";

// import MDBox from "components/MDBox";
// import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// const { Option } = Select;

// // ✅ Validation Schema
// const schema = yup.object().shape({
//   login: yup.string().nullable("Login is required"),
//   key: yup.string().required("Key is required"),
//   file: yup.mixed().required("File is required"),
//   type: yup.string().required("Assignment type required"),
//   users: yup.array().when("assignAll", {
//     is: false,
//     then: (schema) => schema.min(1, "Select at least one user"),
//   }),
//   assignAll: yup.boolean(),
// });

// const Assignment = () => {
//   const {
//     control,
//     handleSubmit,
//     watch,
//     setValue,
//     reset,
//     formState: { errors },
//   } = useForm({
//     defaultValues: {
//       login: "",
//       key: "",
//       file: null,
//       type: "all",
//       users: [],
//       assignAll: false,
//     },
//     resolver: yupResolver(schema),
//   });

//   const assignAll = watch("assignAll");
//   const selectedType = watch("type");

//   const userList = ["Anupam", "Rahul", "John"];
//   const teamList = ["Team A", "Team B"];

//   const onSubmit = (data) => {
//     console.log("Final Data:", data);
//   };

//   return (
//     <DashboardLayout>
//       <DashboardNavbar />

//       <MDBox py={3}>
//         <Typography variant="h4" fontWeight="bold">
//           Assignment
//         </Typography>
//       </MDBox>

//       <Grid container>
//         <Grid item xs={12}>
//           <Card style={{ padding: 24, borderRadius: 16 }}>

//             {/* 🔹 Login + Key */}
//             <Grid container spacing={2}>

//               <Grid item xs={12} md={6}>
//                 <Typography>Key</Typography>
//                 <Controller
//                   name="key"
//                   control={control}
//                   render={({ field }) => (
//                     <Input.Password {...field} placeholder="Enter key" />
//                   )}
//                 />
//                 <p style={{ color: "#ff4d4f", fontSize: "12px", marginTop: 4 }}>{errors.key?.message}</p>
//               </Grid>
//             </Grid>

//             {/* 🔹 File Upload */}
//             <MDBox mt={0}>
//               <Typography>Upload File</Typography>
//               <Controller
//                 name="file"
//                 control={control}
//                 render={({ field }) => (
//                   <Upload
//                     beforeUpload={(file) => {
//                       setValue("file", file);
//                       return false;
//                     }}
//                     maxCount={1}
//                   >
//                     <Button icon={<UploadOutlined />}>Browse</Button>
//                   </Upload>
//                 )}
//               />
//               <p style={{ color: "#ff4d4f", fontSize: "12px", marginTop: 4 }}>{errors.file?.message}</p>
//             </MDBox>

//             {/* 🔹 Assignment Type + User */}
//             <Grid container spacing={2} style={{ marginTop: 20 }}>
//               <Grid item xs={12} md={6}>
//                 <Typography>Assignment Type</Typography>
//                 <Controller
//                   name="type"
//                   control={control}
//                   render={({ field }) => (
//                     <Select
//                       {...field}
//                       style={{ width: "100%" }}
//                       onChange={(val) => field.onChange(val)}
//                     >
//                       <Option value="all">All</Option>
//                       <Option value="team">Team</Option>
//                       <Option value="individual">Individual</Option>
//                     </Select>
//                   )}
//                 />
//               </Grid>

//               {!assignAll && selectedType !== "all" && (
//                 <Grid item xs={12} md={6}>
//                   <Typography>
//                     {selectedType === "team"
//                       ? "Select Team"
//                       : "Select Users"}
//                   </Typography>

//                   <Controller
//                     name="users"
//                     control={control}
//                     render={({ field }) => (
//                       <Select
//                         {...field}
//                         mode="multiple"
//                         style={{ width: "100%" }}
//                         onChange={(val) => field.onChange(val)}
//                       >
//                         {(selectedType === "team"
//                           ? teamList
//                           : userList
//                         ).map((item) => (
//                           <Option key={item} value={item}>
//                             {item}
//                           </Option>
//                         ))}
//                       </Select>
//                     )}
//                   />
//                   <p style={{ color: "#ff4d4f", fontSize: "12px", marginTop: 4 }}>
//                     {errors.users?.message}
//                   </p>
//                 </Grid>
//               )}
//             </Grid>

//             {/* 🔹 Assign All Checkbox */}
//             <MDBox mt={0}>
//               <Controller
//                 name="assignAll"
//                 control={control}
//                 render={({ field }) => (
//                   <Checkbox
//                     checked={field.value}
//                     onChange={(e) =>
//                       field.onChange(e.target.checked)
//                     }
//                   >
//                     Assign to All
//                   </Checkbox>
//                 )}
//               />
//             </MDBox>

//             {/* 🔹 Button */}
//             <MDBox mt={0} display="flex" justifyContent="flex-end">
//               <Button
//                 type="primary"
//                 size="large"
//                 onClick={handleSubmit(onSubmit)}
//               >
//                 Assignment
//               </Button>

//               <Button
//                 style={{ marginLeft: 10 }}
//                 onClick={() => reset()}
//               >
//                 Reset
//               </Button>
//             </MDBox>
//           </Card>
//         </Grid>
//       </Grid>
//     </DashboardLayout>
//   );
// };

// export default Assignment;

import React from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Grid, Card, Typography } from "@mui/material";
import { Input, Select, Button, Checkbox, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";

import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDTypography from "components/MDTypography";

const { Option } = Select;

// ✅ Validation Schema
const schema = yup.object().shape({
  key: yup.string().required("Key is required"),
  file: yup.mixed().required("File is required"),
  type: yup.string().required("Assignment type required"),

  users: yup.array().when("type", {
    is: (type) => type !== "all",
    then: (schema) => schema.min(1, "Select at least one user"),
    otherwise: (schema) => schema.notRequired(),
  }),
});

const Assignment = () => {
  const {
    control,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      key: "",
      file: null,
      type: "all",
      users: [],
      assignAll: false,
    },
    resolver: yupResolver(schema),
  });

  const assignAll = watch("assignAll");
  const selectedType = watch("type");

  const userList = ["Anupam", "Rahul", "John"];
  const teamList = ["Team A", "Team B"];

  // ✅ NEW STATES (logs + progress)
  const [logs, setLogs] = React.useState([]);
  const [progress, setProgress] = React.useState(0);
  const [uploadedFiles, setUploadedFiles] = React.useState([]);

  // ✅ helpers
  const addLog = (msg) => {
    const time = new Date().toLocaleTimeString();
    setLogs((prev) => [...prev, `[${time}] ${msg}`]);
  };

  const updateProgress = (val) => {
    setProgress(val);
  };

  console.log(errors?.users?.message);
  // ✅ Submit handler (mock upload)
  const onSubmit = async (data) => {
    console.log("Final Data:", data);

    addLog("Upload started...");
    updateProgress(10);

    try {
      addLog(`Uploading file: ${data.file?.name}`);

      await new Promise((res) => setTimeout(res, 1000));
      updateProgress(50);

      await new Promise((res) => setTimeout(res, 1000));
      updateProgress(100);

      addLog("Upload successful ✅");

      setUploadedFiles((prev) => [...prev, data.file?.name || "File"]);
    } catch (e) {
      addLog("Upload failed ❌");
    } finally {
      setTimeout(() => updateProgress(0), 1000);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox py={3}>
        <Typography variant="h4" fontWeight="bold">
          Assignment
        </Typography>
      </MDBox>

      <Grid container>
        <Grid item xs={12}>
          <Card style={{ padding: 24, borderRadius: 16 }}>
            {/* 🔹 Key */}
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <MDTypography>
                  Key
                  <MDTypography />
                </MDTypography>{" "}
                <Controller
                  name="key"
                  control={control}
                  render={({ field }) => <Input.Password {...field} placeholder="Enter key" />}
                />
                <p style={{ color: "#ff4d4f", fontSize: "12px", marginTop: 4 }}>
                  {errors.key?.message}
                </p>
              </Grid>
            </Grid>

            {/* 🔹 File Upload */}
            <MDBox mt={2}>
              <Typography>Upload File</Typography>
              <Controller
                name="file"
                control={control}
                render={() => (
                  <Upload
                    beforeUpload={(file) => {
                      setValue("file", file);
                      addLog(`File selected: ${file.name}`);
                      return false;
                    }}
                    maxCount={1}
                  >
                    <Button icon={<UploadOutlined />}>Browse</Button>
                  </Upload>
                )}
              />
              <p style={{ color: "#ff4d4f", fontSize: "12px", marginTop: 4 }}>
                {errors.file?.message}
              </p>
            </MDBox>

            {/* 🔹 Progress */}
            {progress > 0 && (
              <MDBox mt={2}>
                <progress value={progress} max="100" style={{ width: "100%" }} />
                <Typography>{progress}%</Typography>
              </MDBox>
            )}

            {/* 🔹 Assignment Type + User */}
            <Grid container spacing={2} style={{ marginTop: 20 }}>
              <Grid item xs={12} md={6}>
                <Typography>Assignment Type</Typography>
                <Controller
                  name="type"
                  control={control}
                  render={({ field }) => (
                    <Select
                      {...field}
                      style={{ width: "100%" }}
                      onChange={(val) => field.onChange(val)}
                    >
                      <Option value="all">All</Option>
                      <Option value="team">Team</Option>
                      <Option value="individual">Individual</Option>
                    </Select>
                  )}
                />
              </Grid>

              {!assignAll && selectedType !== "all" && (
                <Grid item xs={12} md={6}>
                  <Typography>
                    {selectedType === "team" ? "Select Team" : "Select Users"}
                  </Typography>

                  <Controller
                    name="users"
                    control={control}
                    render={({ field }) => (
                      <Select
                        {...field}
                        mode="multiple"
                        style={{ width: "100%" }}
                        onChange={(val) => field.onChange(val)}
                      >
                        {(selectedType === "team" ? teamList : userList).map((item) => (
                          <Option key={item} value={item}>
                            {item}
                          </Option>
                        ))}
                      </Select>
                    )}
                  />
                </Grid>
              )}
              <p style={{ color: "#ff4d4f", fontSize: "12px", marginTop: 4 }}>
                {errors.users?.message}
              </p>
            </Grid>

            {/* 🔹 Assign All
            <MDBox mt={2}>
              <Controller
                name="assignAll"
                control={control}
                render={({ field }) => (
                  <Checkbox
                    checked={field.value}
                    onChange={(e) => field.onChange(e.target.checked)}
                  >
                    Assign to All
                  </Checkbox>
                )}
              />
            </MDBox> */}

            {/* 🔹 Buttons */}
            <MDBox mt={2} display="flex" justifyContent="flex-end">
              <Button type="primary" size="medium" onClick={handleSubmit(onSubmit)}>
                Assignment
              </Button>

              <Button style={{ marginLeft: 10 }} type="secondary" onClick={() => reset()}>
                Reset
              </Button>
            </MDBox>

            {/* 🔹 Logs */}
            <MDBox mt={3}>
              <Typography variant="h6">Status Logs</Typography>

              <div
                style={{
                  height: 150,
                  overflowY: "auto",
                  background: "#fafafa",
                  padding: 10,
                  border: "1px solid #ddd",
                  fontFamily: "monospace",
                  fontSize: 12,
                }}
              >
                {logs.map((log, i) => (
                  <div key={i}>{log}</div>
                ))}
              </div>
            </MDBox>

            {/* 🔹 Uploaded Files */}
            <MDBox mt={2}>
              <Typography variant="h6">Uploaded Files</Typography>
              <ul>
                {uploadedFiles.map((f, i) => (
                  <li key={i}>{f}</li>
                ))}
              </ul>
            </MDBox>
          </Card>
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};

export default Assignment;
